import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * False while React hydrates a pre-rendered page, then true. The pre-rendered
 * HTML is always the signed-out view, so anything that depends on the browser
 * (who is signed in) must wait for this, or the page would be redrawn from
 * scratch. On a normal (not pre-rendered) load it is true from the start.
 */
export function useHydrated() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
